import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BenefitEditPage } from './BenefitEditPage';

const searchSchema = z.object({
  type: z.enum(['demo', 'live']).optional(),
});

export const Route = createFileRoute('/_protected/admin/benefits/$benefitId/edit/')({
  component: BenefitEditPage,
  validateSearch: searchSchema,
});
